module.exports = __webpack_public_path__ + "img/icono_horizontal.1a83451f.svg";